import React from 'react';
import { MutableSnapshot, RecoilRoot } from 'recoil';
import {
  ActiveModelState,
  CompareRangeModel,
  ModelWalkModelsState,
} from './store';
import { ModelWalkBlockContent } from './model-walk-vehicle';
import { PageLayout } from '~/common/components';

interface ModelWalkBlockProps {
  modelWalkContent: CompareRangeModel[];
  isTabView: boolean;
}

export const ModelWalkBlock = (props: ModelWalkBlockProps) => {
  const initialize = ({ set }: MutableSnapshot) => {
    set(ModelWalkModelsState, props.modelWalkContent);

    if (props.modelWalkContent.length > 0) {
      set(ActiveModelState, props.modelWalkContent[0]);
    }
  };

  return (
    <RecoilRoot initializeState={initialize}>
      <PageLayout>
        <ModelWalkBlockContent isTabView={props.isTabView} />
      </PageLayout>
    </RecoilRoot>
  );
};
